import { h, Component } from 'preact';
import Button from 'components/bolt/button/button';
import Screening from 'components/bolt/showtimes/screening';
import Tooltip from 'components/bolt/tooltip/tooltip';
import { accessNested, joinClasses } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt/showtimes.js';

import s from 'components/bolt/showtimes/groupBooking.sss';

const InfoIcon = (
	<svg class={s.infoIcon} width="2" height="10" viewBox="0 0 2 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M0.999713 0.20166C0.553313 0.20166 0.191017 0.563956 0.191017 1.01036C0.191017 1.45676 0.553313 1.81905 0.999713 1.81905C1.44611 1.81905 1.80841 1.45676 1.80841 1.01036C1.80841 0.563956 1.44611 0.20166 0.999713 0.20166Z" />
		<path d="M0.190918 3.84036C0.190918 3.39373 0.552984 3.03166 0.999614 3.03166C1.44624 3.03166 1.80831 3.39373 1.80831 3.84036V8.69253C1.80831 9.13916 1.44624 9.50123 0.999614 9.50123C0.552984 9.50123 0.190918 9.13916 0.190918 8.69253V3.84036Z" />
	</svg>
);

export default class GroupBooking extends Component {
	constructor(props) {
		super(props);
		const theaterChainSlug = props.theater.chain.slug;
		const showtimesData = getShowtimesData();
		this.showPrivateTheaterRental = accessNested(showtimesData, `groupBookings.privateRentalChains.${theaterChainSlug}`, false);
	}
	onTooltipHide = (isMobile) => {
		if (isMobile) {
			const scrollSearch = document.querySelector('#scrollSearch');
			if (scrollSearch) scrollSearch.style.zIndex = '4';
			const scrollDates = document.querySelector('#scrollDates');
			if (scrollDates) scrollSearch.style.zIndex = '3';

		}
	}
	onTooltipShow = (isMobile) => {
		if (isMobile) {
			const scrollSearch = document.querySelector('#scrollSearch');
			if (scrollSearch) scrollSearch.style.zIndex = '2';

			const scrollDates = document.querySelector('#scrollDates');
			if (scrollDates) scrollDates.style.zIndex = '2';
		}
	}
	render(props) {
		const { copy, screenings, theater, mode, trackConversion, showtimesAppData, client, eventInquiryTrigger } = props;
		const { groupBookings } = showtimesAppData;
		const isMobile = client.deviceSize === 'mobile';
		let ptrScreenings = theater.screenings.filter(screening => screening.format === 'PTR');
		if (ptrScreenings.length === 0) {
			this.showPrivateTheaterRental = false;
			ptrScreenings = screenings;
		}


		return (
			<div className={joinClasses(s.container, mode === 'expanded' && s.theaterExpanded)}>
				<div className={s.booking}>
					<div className={s.label}>{copy.baseCopy.$THEATER_GROUP_BOOKING_LABEL}</div>
					<Button
						type="time"
						trigger={() => {
							eventInquiryTrigger();
						}}
						// disabled={}
						ariaLabel={copy.baseCopy.$THEATER_GROUP_BOOKING_BUTTON}
					>
						{copy.baseCopy.$THEATER_GROUP_BOOKING_BUTTON}
					</Button>
				</div>

				{this.showPrivateTheaterRental && (
					<div className={s.rental}>
						<div className={s.inner}>
							<div className={s.label}>{copy.baseCopy.$THEATER_PRIVATE_RENTAL}</div>
							<div className={s.info}>
								<Tooltip
									ref={ref => this.$tooltip = ref?.base}
									data={groupBookings?.privateTheaterRentalTooltip}
									isMobile={isMobile}
									position={'topRight'}
									onHide={() => this.onTooltipHide(isMobile)}
									onShow={() => this.onTooltipShow(isMobile)}
								>
									{InfoIcon}
								</Tooltip>
							</div>
						</div>

						{/* FOR UI DUMMY DATA DISPLAY ONLY - this is not actually dummy? */}
						{ptrScreenings.sort((a, b) => a.time.localeCompare(b.time)).map(screening => (
							<Screening
								screening={screening}
								theater={theater}
								showtimesAppData={showtimesAppData}
								mode={mode}
								trackConversion={trackConversion}
								isPreviewPanelScreening={mode === 'film'}
							/>
						))}
						{/* FOR UI DUMMY DATA DISPLAY ONLY */}

					</div>
				)
				}

			</div>
		);
	}
}
